import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, del } from './agent';

// Keyed by the client's own identifier, which for a metadata-document client is a URL — so it is
// encoded into the path rather than passed raw.
const oauthConnections =
  (workspacesUrl) =>
  (clientId = '') => {
    const url = _([workspacesUrl, 'oauth-connections', clientId && encodeURIComponent(clientId)])
      .compact()
      .join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      disconnect: () => del(url),
    };
  };

export default oauthConnections;
